"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownRole = exports.permissionGroups = exports.PermissionGroup = exports.KnownPolicyPermission = void 0;
var KnownPolicyPermission;
(function (KnownPolicyPermission) {
    KnownPolicyPermission["SSOSessionCreate"] = "sso_session.create";
    KnownPolicyPermission["ManageUsers"] = "users:manage";
    KnownPolicyPermission["CustomerView"] = "customer:view";
    KnownPolicyPermission["CustomerUpdate"] = "customer:update";
    KnownPolicyPermission["CustomerDocumentsUpload"] = "customer:upload_documents";
    KnownPolicyPermission["CustomerDocumentsView"] = "customer:view_documents";
    KnownPolicyPermission["TermDepositView"] = "term_deposit:view";
    KnownPolicyPermission["TermDepositApply"] = "term_deposit:apply";
    KnownPolicyPermission["TermDepositAmendOrTerminate"] = "term_deposit:amend_or_terminate";
    KnownPolicyPermission["TermDepositChangeDisbursementIban"] = "term_deposit:change_disbursement_iban";
    KnownPolicyPermission["TermDepositProlongContract"] = "term_deposit:prolong_contract";
    KnownPolicyPermission["TermDepositConcludeContract"] = "term_deposit:conclude_contract";
    KnownPolicyPermission["SavingDepositView"] = "savings_deposit:view";
    KnownPolicyPermission["SavingDepositApply"] = "savings_deposit:apply";
    KnownPolicyPermission["SavingDepositWithdraw"] = "savings_deposit:withdraw";
    KnownPolicyPermission["SavingDepositConcludeContract"] = "savings_deposit:conclude_contract";
    KnownPolicyPermission["LoanView"] = "loan:view";
    KnownPolicyPermission["LoanApply"] = "loan:apply";
    KnownPolicyPermission["LoanAmendOrTerminate"] = "loan:amend_or_terminate";
    KnownPolicyPermission["LoanSubmitAmendmentRequest"] = "loan:submit_amendment_request";
    KnownPolicyPermission["LeasingView"] = "leasing:view";
    KnownPolicyPermission["LeasingApply"] = "leasing:apply";
    KnownPolicyPermission["LeasingAmendOrTerminate"] = "leasing:amend_or_terminate";
    KnownPolicyPermission["LeasingSubmitAmendmentRequest"] = "leasing:submit_amendment_request";
})(KnownPolicyPermission || (exports.KnownPolicyPermission = KnownPolicyPermission = {}));
var PermissionGroup;
(function (PermissionGroup) {
    PermissionGroup["Login"] = "LOGIN";
    PermissionGroup["Admin"] = "ADMIN";
    PermissionGroup["CustomerData"] = "CUSTOMER_DATA";
    PermissionGroup["TermDeposit"] = "TERM_DEPOSIT";
    PermissionGroup["SavingDeposit"] = "SAVING_DEPOSIT";
    PermissionGroup["Loan"] = "LOAN";
    PermissionGroup["Leasing"] = "LEASING";
})(PermissionGroup || (exports.PermissionGroup = PermissionGroup = {}));
exports.permissionGroups = Object.freeze({
    [PermissionGroup.Login]: [
        KnownPolicyPermission.SSOSessionCreate,
    ],
    [PermissionGroup.Admin]: [
        KnownPolicyPermission.ManageUsers,
    ],
    [PermissionGroup.CustomerData]: [
        KnownPolicyPermission.CustomerView,
        KnownPolicyPermission.CustomerUpdate,
        KnownPolicyPermission.CustomerDocumentsUpload,
        KnownPolicyPermission.CustomerDocumentsView,
    ],
    [PermissionGroup.TermDeposit]: [
        KnownPolicyPermission.TermDepositView,
        KnownPolicyPermission.TermDepositApply,
        KnownPolicyPermission.TermDepositAmendOrTerminate,
        KnownPolicyPermission.TermDepositChangeDisbursementIban,
        KnownPolicyPermission.TermDepositProlongContract,
        KnownPolicyPermission.TermDepositConcludeContract,
    ],
    [PermissionGroup.SavingDeposit]: [
        KnownPolicyPermission.SavingDepositView,
        KnownPolicyPermission.SavingDepositApply,
        KnownPolicyPermission.SavingDepositWithdraw,
        KnownPolicyPermission.SavingDepositConcludeContract,
    ],
    [PermissionGroup.Loan]: [
        KnownPolicyPermission.LoanView,
        KnownPolicyPermission.LoanApply,
        KnownPolicyPermission.LoanAmendOrTerminate,
        KnownPolicyPermission.LoanSubmitAmendmentRequest,
    ],
    [PermissionGroup.Leasing]: [
        KnownPolicyPermission.LeasingView,
        KnownPolicyPermission.LeasingApply,
        KnownPolicyPermission.LeasingAmendOrTerminate,
        KnownPolicyPermission.LeasingSubmitAmendmentRequest,
    ]
});
var KnownRole;
(function (KnownRole) {
    KnownRole["AuthenticationFullAccess"] = "authentication.full_access";
})(KnownRole || (exports.KnownRole = KnownRole = {}));
